module.exports = __webpack_public_path__ + "img/livepen-info-m.b289bfac.png";